import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
} from "react";

export const AdminPreviewContext = createContext(null);

export const AdminPreviewProvider = ({
  children,
  preview: initial,
}: PropsWithChildren<{ preview: boolean }>) => {
  const [preview, setPreview] = useState(initial);

  return (
    <AdminPreviewContext.Provider value={{ preview, setPreview }}>
      {children}
    </AdminPreviewContext.Provider>
  );
};

export const useAdminPreview = () => {
  return useContext(AdminPreviewContext);
};
